<template>
  <!-- w-32 h-31  -->
  <circle cx='15.5' cy='15.5' r='11.75' stroke='#95A4C0' stroke-width='1.5' />
  <circle cx='15.5' cy='15.5' r='2.75' stroke='#95A4C0' stroke-width='1.5' />
</template>
